var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightSm = function SvgChevronRightSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-right-sm_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m24.21 18.13-2.13 2.13 6.37 6.37L34.82 33l-6.37 6.37-6.37 6.37 2.13 2.13L26.34 50l8.5-8.5 8.5-8.5-8.5-8.5-8.5-8.5z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronRightSm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0LjIxIDE4LjEzTDIyLjA4IDIwLjI2TDI4LjQ1IDI2LjYzTDM0LjgyIDMzTDI4LjQ1IDM5LjM3MDFMMjIuMDggNDUuNzQwMkwyNC4yMTAxIDQ3Ljg3MDFMMjYuMzQwMiA0OS45OTk5TDM0Ljg0MDEgNDEuNUw0My4zNCAzM0wzNC44NCAyNC41TDI2LjM0IDE2TDI0LjIxIDE4LjEzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";